import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { FluentProvider, teamsLightTheme } from '@fluentui/react-components'
import { TeamsProvider } from './providers/TeamsProvider'
import { App } from './App'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <FluentProvider theme={teamsLightTheme}>
      <BrowserRouter>
        <TeamsProvider>
          <App />
        </TeamsProvider>
      </BrowserRouter>
    </FluentProvider>
  </React.StrictMode>,
)
